import toast from 'react-hot-toast';

import { MessageBlock, MessageBlockContent } from '@cfa/react-components';

import { SuccessToastProps } from '@/types/types';

const ToastMessageBlock: React.FC<SuccessToastProps> = ({
  children,
  id,
  severity,
  title,
}) => (
  <MessageBlock
    data-testid="Toast"
    onClose={() => toast.remove(id)}
    severity={severity}
    title={title}
  >
    <MessageBlockContent>{children}</MessageBlockContent>
  </MessageBlock>
);

export default ToastMessageBlock;
